import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import ScrollableBox from '@activebrands/core-web/components/ScrollableBox';
import { TrackingLists } from '@activebrands/core-web/libs/Tracking/constants';
import { styled } from '@activebrands/core-web/libs/styletron';
import transformProductCardMiniData from '@activebrands/core-web/utils/product/transform-product-card-mini-data';
import ProductCardMini from 'components/product/ProductCardMini';

const Wrapper = styled(ScrollableBox, {
    borderRadius: '4px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    height: '100%',
});

const ProductCardMiniWrapper = styled('div', {
    padding: '4px',
    backgroundColor: 'var(--color-bg-checkout-summary-products)',
    borderBottom: '1px solid var(--color-border-checkout-subtle)',
});

const BasketItems = ({ previewStateOverride = false, productCardType = 'basket', ...rest }) => {
    const items = useSelector(state => state.basket.items);

    return (
        <Wrapper withScrollbar {...rest}>
            {items?.map(product => {
                const productData = transformProductCardMiniData({ product: product, source: 'Centra' });

                return (
                    <ProductCardMiniWrapper key={product.id}>
                        <ProductCardMini
                            innerWrapperStyle={{
                                backgroundColor: 'var(--color-bg-badge',
                                padding: [
                                    'var(--margin-content)',
                                    null,
                                    null,
                                    null,
                                    null,
                                    '12px var(--margin-content)',
                                ],
                            }}
                            line={product.line}
                            trackingList={TrackingLists.CHECKOUT_LIST}
                            type={productCardType}
                            showFavorite={false}
                            {...productData}
                            media={productData.media?.[0] ?? {}}
                        />
                    </ProductCardMiniWrapper>
                );
            })}
            {/* previewStateOverride is used by storyblok preview */}
            {previewStateOverride && (
                <ProductCardMiniWrapper>
                    <ProductCardMini
                        $style={{ backgroundColor: 'transparent' }}
                        item={{
                            id: undefined,
                            line: undefined,
                            quantity: 2,
                            url: '#',
                            media: {
                                sizes: {
                                    full: {
                                        url: 'https://via.placeholder.com/96x128',
                                    },
                                },
                            },
                            productName: 'Preview product',
                            size: 'M',
                            price: { salePriceWithCurrency: 99, priceWithCurrency: 149 },
                        }}
                        key="previewStateOverride"
                        showFavorite={false}
                    />
                </ProductCardMiniWrapper>
            )}
        </Wrapper>
    );
};

BasketItems.propTypes = {
    previewStateOverride: PropTypes.bool,
    productCardType: PropTypes.string,
};

export default BasketItems;
